import { gql, useFragment } from "@apollo/client";

// Styling
import style from "./logo.module.scss";

// Constants
import { imgFields } from "@/constants/gql-fields";

// Components
import Link from "next/link";

export default function Logo({ entry }) {
  // Use Fragment
  const { complete, data } = useFragment({
    fragment: Logo.fragments.entry,
    fragmentName: "LogoFragment",
    from: {
      __typename: entry.__typename,
      id: entry.id,
    },
  });
  if (!complete) {
    return;
  }

  // Define Variables
  const logoImage = data.logoImage;
  var logoItem = "";
  var logoWidth = "";
  var logoStyling = "";

  if (data.logoMW) {
    logoWidth = {
      maxWidth: data.logoMW,
      width: data.logoMW,
    };
  }

  // Logo Types
  switch (data.logoType) {
    case "text":
      logoItem = data.logoText;
      break;
    case "svg":
      logoItem = (
        <div
          className={style.logoSVG}
          dangerouslySetInnerHTML={{ __html: data.logoSvgCode }}
        />
      );
      break;
    case "image":
      logoStyling = {
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
      };
      logoItem = (
        <img
          src={logoImage.node.sourceUrl}
          alt={logoImage.node.altText ?? ""}
          style={logoStyling}
          fetchPriority="high"
        />
      );
      break;
    default:
      logoItem = "ACF Kitchen";
      break;
  }

  return (
    <div className={style.logoContainer} style={logoWidth}>
      <Link href="/" className="logo">
        {logoItem}
        {/* <svg
          className="divider"
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="34"
          viewBox="0 0 8 34"
          fill="none"
        >
          <path d="M7.25154 0.581786L1.24826 33.4179" stroke="black" />
        </svg>
        <p>Good to Know</p> */}
      </Link>
    </div>
  );
}

Logo.fragments = {
  entry: gql`
    fragment LogoFragment on GeneralSettingsACFLogo {
      id
      __typename
      logoMW
      logoSvgCode
      logoText
      logoType
      logoImage {
        ${imgFields}
      }
    }
  `,
};
